module.exports = __webpack_public_path__ + "img/DE00487.d5e1b67c.png";